import React, { useEffect, useRef, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import useClickOutside from "../../hooks/useClickOutside";
import { getFieldIcon } from "../../utils/getFieldIcon";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import Button from "../FormComponents/Button";
import ButtonPreview from "./ButtonPreview";
import DropdownPreview from "./DropdownPreview";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import PositionedScreen, { usePositionedScreenContext } from "../../Pages/FlexibleLayout/PositionedScreen";
import LayoutRendererOuter from "../../Pages/FlexibleLayout/LayoutRenderer/LayoutRendererOuter";
import { generateObjectId } from "../../utils/objectIdUtils";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import { toastError } from "../../utils/toastUtils";

const initialModalState = {
  show: false,
  name: "",
  type: "",
  data: null
};
const RVTablePreview = ({ config, classes, saveConfig, onClickElement, type, node }) => {
  const [isCatalogPreview, setIsCatalogPreview] = useState(false);
  const [modalState, setModalState] = useState(initialModalState);
  const { tableId, tableType } = usePositionedScreenContext();

  const openModal = (name, type, data) => {
    setModalState({
      show: true,
      name,
      type,
      data
    });
  };
  const closeModal = () => {
    setModalState(initialModalState);
  };
  const handleEvents = (type, id, config = null, other = null) => {
    onClickElement({
      type,
      config,
      id,
      other
    });
  };

  const handleAddColumn = (data) => {
    if (data.type === "toggle_layout") {
      setIsCatalogPreview(!isCatalogPreview);
    }
    if (data.type === "edit_catalog") {
      handleEvents(data.type);
    }
    if (data.type === "field") {
      // handleEvents("add_field_to_column");
      openModal("Add Field", "add_field_to_column");
    }
    if (data.type === "custom") {
      if (data.column.custom_type === "rich_column") {
        data.column.layout_config.layouts = [
          {
            id: generateObjectId(),
            classes: [],
            children: [],
            type: "section",
            style: {
              width: "100%",
              height: "60px",
              position: "relative"
            }
          }
        ];
      }
      saveConfig({ ...config, columns: [...config.columns, data.column] });
    }
  };
  const handleChangeColumns = (data) => {
    if (data.action === "update_rich_column_layout") {
      const newConfig = {
        ...config,
        columns: config.columns.map((co) => {
          if (co.id === data.id) {
            return {
              ...co,
              layout_config: {
                ...co.layout_config,
                layouts: data.newLayoutConfig
              }
            };
          }
          return co;
        })
      };
      saveConfig(newConfig);
    }
    if (data.action === "delete") {
      saveConfig({ ...config, columns: config.columns.filter((co) => co.id !== data.id) });
    }
    if (data.action === "add") {
      // handleEvents("add_field_after_column_with_index", data.id, data.column);
      openModal("Add Field", "add_field_after_column_with_id", { column: data.column });
    }
    if (data.action === "change") {
      openModal("Change Field", "change_field", { column: data.column });
    }
    if (data.action === "sort") {
      saveConfig({ ...config, columns: data.allColumns });
    }
    if (data.action === "edit") {
      handleEvents("edit_column", data.id, data.column);
    }
    if (data.action === "add_field_rich_column") {
      handleEvents("add_field_rich_column", data.id, data.column);
    }
  };

  const handleField = (data) => {
    const updatedConfig = JSON.parse(JSON.stringify(config));

    const idExists = updatedConfig.columns.some((column) => column.id === data.id);
    if (idExists) {
      toastError(`column is already exists.`);
      return;
    }
    if (modalState.type === "add_field_to_column") {
      updatedConfig.columns.push(data);
      saveConfig(updatedConfig, node.id);
    }
    if (modalState.type === "change_field") {
      updatedConfig.columns = updatedConfig.columns.map((column) => {
        if (column.id === modalState.data.column.id) {
          return data;
        }
        return column;
      });
      saveConfig(updatedConfig, node.id);
      closeModal();
    }
    if (modalState.type === "add_field_after_column_with_id") {
      const newColumns = updatedConfig.columns.slice();
      const index = newColumns.findIndex((column) => column.id === modalState.data.column.id);
      if (index >= 0 && index < newColumns.length - 1) {
        newColumns.splice(index + 1, 0, data);
        updatedConfig.columns = newColumns;
        saveConfig(updatedConfig, node.id);
      } else {
        toastError("Column not found.");
      }

      closeModal();
    }
  };

  useEffect(() => {
    if (config.layout_type === "table_view" || config.layout_type === "table_and_catalog_view") {
      setIsCatalogPreview(false);
    }
    if (config.layout_type === "catalog_view" || config.layout_type === "catalog_and_table_view") {
      setIsCatalogPreview(true);
    }
  }, [config.layout_type]);

  return (
    <div className="rv_table_preview">
      <div className="position_relative">
        {type === "editable" && (
          <div className="add_column_icon">
            <RVTableAddFieldActions
              handleAddColumn={handleAddColumn}
              layoutType={config.layout_type}
              isCatalogViewVisible={isCatalogPreview}
            />
          </div>
        )}
        {isCatalogPreview && (
          <div className={classes}>
            <RVCatalogPreview catalog={config.catalog || {}} width={parseInt(node.style.width)} id={node.id} />
          </div>
        )}
        {!isCatalogPreview && (
          <>
            <div className={`z-rv-table-preview ${classes}`}>
              <div className="z-rv-table-wrapper">
                <RVTableViewColumns
                  columns={config.columns}
                  handleChangeColumns={handleChangeColumns}
                  type={type}
                  node={node}
                />
              </div>
              {!config.disable_pagination && (
                <div className="rv-footer">
                  <div className="d_flex gap_3 align_center ml_auto w_fit">
                    <div className="d_flex gap_2 align_center ">
                      <div className="rv_footer_icon d_flex align_center gap_1">
                        <span>10</span>
                        <MaterialIcon name="keyboard_arrow_down" />{" "}
                      </div>
                      <div className="z-text-default">1-1 of 1</div>
                    </div>

                    <div className="d_flex gap_2 align_center ">
                      <div className="rv_footer_icon">1</div>
                      <div className="rv_footer_icon d_flex align_center gap_1">
                        <span>10</span>
                        <MaterialIcon name="keyboard_arrow_down" />{" "}
                      </div>
                      <div className="rv_footer_icon">1</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <BuilderModal isOpen={modalState.show} onClose={closeModal} modalName={modalState.name}>
        <TableTreeModal callbackFunction={handleField} tableId={tableId || ""} tableType={tableType || ""} />
      </BuilderModal>
    </div>
  );
};

function RichColumnLayoutRenderer({ cardIndex, layout, cardWidth, id, path }) {
  const {
    draggedItem,
    hoveredItemId,
    selectedItem,
    saveEditElement,
    onClickElement,
    handleResizeStart,
    handleOnDrop,
    handleClick,
    handleDragOver,
    handleDragStart,
    type,
    hoveredDirectItemId,
    setHoveredDirectItemId,
    multiSelectedItems,
    handleRightClick
  } = usePositionedScreenContext();
  return (
    <div
      style={{
        width: `${cardWidth}px`
      }}
    >
      <LayoutRendererOuter
        key={cardIndex}
        layoutConfig={layout}
        draggedItem={draggedItem}
        hoveredItemId={hoveredItemId}
        selectedItem={selectedItem}
        type={type}
        saveEditElement={saveEditElement}
        handleOnDrop={handleOnDrop}
        onClickElement={onClickElement}
        handleResizeStart={handleResizeStart}
        handleClick={handleClick}
        handleRightClick={handleRightClick}
        handleDragOver={handleDragOver}
        handleDragStart={handleDragStart}
        hoveredDirectItemId={hoveredDirectItemId}
        setHoveredDirectItemId={setHoveredDirectItemId}
        multiSelectedItems={multiSelectedItems}
        device={"desktop"}
        catalogPathInfo={{
          path: [id, path]
        }}
      />
    </div>
  );
}

const RVCatalogPreview = ({ catalog, width, rows = 3, id }) => {
  const {
    draggedItem,
    hoveredItemId,
    selectedItem,
    saveEditElement,
    onClickElement,
    handleResizeStart,
    handleOnDrop,
    handleClick,
    handleDragOver,
    handleDragStart,
    type,
    hoveredDirectItemId,
    setHoveredDirectItemId,
    multiSelectedItems,
    handleRightClick
  } = usePositionedScreenContext();

  if (!width) return "Width is required";

  const { cards_per_row = 1, gap_between_cards = 18, layout = [] } = catalog;

  const gapCount = cards_per_row - 1;
  const totalGap = gapCount * parseInt(gap_between_cards);
  const totalWidth = width - totalGap;
  const cardWidth = Math.floor(totalWidth / cards_per_row);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: `${gap_between_cards}px`
      }}
    >
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "flex",
            gap: `${gap_between_cards}px`
          }}
        >
          {Array.from({ length: cards_per_row }).map((_, cardIndex) => {
            if (rowIndex === 0 && cardIndex === 0) {
              return (
                <div style={{ width: `${cardWidth}px` }} key={cardIndex}>
                  <LayoutRendererOuter
                    key={cardIndex}
                    layoutConfig={layout}
                    draggedItem={draggedItem}
                    hoveredItemId={hoveredItemId}
                    selectedItem={selectedItem}
                    type={type}
                    saveEditElement={saveEditElement}
                    handleOnDrop={handleOnDrop}
                    onClickElement={onClickElement}
                    handleResizeStart={handleResizeStart}
                    handleClick={handleClick}
                    handleRightClick={handleRightClick}
                    handleDragOver={handleDragOver}
                    handleDragStart={handleDragStart}
                    hoveredDirectItemId={hoveredDirectItemId}
                    setHoveredDirectItemId={setHoveredDirectItemId}
                    multiSelectedItems={multiSelectedItems}
                    device={"desktop"}
                    catalogPathInfo={{ path: [id, "config.catalog.layout"] }}
                  />
                </div>
              );
            }
            return (
              <PositionedScreen
                key={cardIndex}
                layoutConfig={layout}
                type={"view"}
                screenWidth={cardWidth}
                containerClass=""
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

const RVTableAddFieldActions = ({ handleAddColumn, layoutType, isCatalogViewVisible }) => {
  const [isCustomColumListOpen, setIsCustomColumListOpen] = useState(false);

  const customRef = useRef();

  useClickOutside(customRef, () => setIsCustomColumListOpen(false));

  const addCustomColumn = (e, type) => {
    e.stopPropagation();
    const customColumnConfig = {
      aggregate_column: "",
      aggregate_function: "",
      custom_type: type, //button aggregate_column rich_column
      type: "custom",
      display: "custom",
      config: [],
      layout_config: {
        layouts: []
      },
      id: generateObjectId()
    };
    handleAddColumn({
      type: "custom",
      column: customColumnConfig
    });
    setIsCustomColumListOpen(false);
  };

  return (
    <div className="recordview_add_field_custom_column">
      {layoutType !== "table_view" && layoutType !== "catalog_view" && (
        <Button
          size="small"
          title="Add Field"
          onClick={(e) => {
            e.stopPropagation();
            handleAddColumn({
              type: "toggle_layout",
              column: null
            });
          }}
        >
          <MaterialIcon name="stars" style={{ fontSize: "12px" }} />
        </Button>
      )}
      {isCatalogViewVisible && (
        <Button
          size="small"
          title="Add Field"
          onClick={(e) => {
            e.stopPropagation();
            handleAddColumn({
              type: "edit_catalog",
              column: null
            });
          }}
        >
          <MaterialIcon name="assistant_direction" style={{ fontSize: "12px" }} />
        </Button>
      )}
      {!isCatalogViewVisible && (
        <>
          <Button
            size="small"
            title="Add Field"
            onClick={(e) => {
              e.stopPropagation();
              handleAddColumn({
                type: "field",
                column: null
              });
            }}
          >
            <MaterialIcon name="add" style={{ fontSize: "12px" }} />
          </Button>
          <div className="position_relative" ref={customRef}>
            <Button
              size="small"
              variant="secondary"
              onClick={(e) => {
                e.stopPropagation();
                setIsCustomColumListOpen(!isCustomColumListOpen);
              }}
              title="Add Custom Column"
            >
              <MaterialIcon name="splitscreen_vertical_add" style={{ fontSize: "12px" }} />
            </Button>
            {isCustomColumListOpen && (
              <div className="recordview_custom_column_option_popover">
                <div onClick={(e) => addCustomColumn(e, "button")}>Button</div>
                <div onClick={(e) => addCustomColumn(e, "aggregate_column")}>Aggregate Column</div>
                <div onClick={(e) => addCustomColumn(e, "rich_column")}>Rich Column</div>
                {/* <div onClick={(e) => addCustomColumn(e, "new_rich_column")}>New Rich Column</div> */}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
const RVTableViewColumns = ({ columns, handleChangeColumns, type, node }) => {
  const isMounted = useRef(false);

  const setSortableColumns = (columns) => {
    if (type !== "editable") return;
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    const cleanItems = columns.map((item) => {
      const { ...rest } = item;
      return rest;
    });
    const copyColumns = JSON.parse(JSON.stringify(cleanItems));
    handleChangeColumns({
      action: "sort",
      allColumns: copyColumns
    });
  };

  const renderActionIcon = (action, column, id, icon) => (
    <ButtonActionIcon
      size="xsm"
      type={icon}
      onClick={(e) => {
        e.stopPropagation();
        handleChangeColumns({
          action,
          id,
          column,
          type: column.type
        });
      }}
    />
  );

  const handleDragStart = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <table>
        <thead className="z-rv-table-header">
          {columns.length > 0 ? (
            <ReactSortable
              tag="tr"
              list={JSON.parse(JSON.stringify(columns))}
              setList={setSortableColumns}
              animation={200}
              disabled={type !== "editable"}
            >
              {columns.map((column) => (
                <th
                  key={column.id}
                  className="recordview_table_column_header"
                  title={(column?.prefix ? column.prefix + "." : "") + (column?.display || "----")}
                  onDragStart={handleDragStart}
                >
                  <div className="d_flex align_center gap_2">
                    <MaterialIcon name={getFieldIcon(column.field_type)} className="font_size_medium" />
                    <span>{column.custom_label || column.display || "----"}</span>
                  </div>
                  {type === "editable" && (
                    <div className="recordview_table_column_action">
                      {column.type === "custom" &&
                        column.custom_type === "rich_column" &&
                        renderActionIcon("add_field_rich_column", column, column.id, "apps")}
                      {renderActionIcon("edit", column, column.id, "edit")}
                      {renderActionIcon("change", column, column.id, "refresh")}
                      {(column.field_type === "grid" ||
                        column.field_type === "recordset" ||
                        column.field_type === "recordset-list") &&
                        renderActionIcon("recordset_layout", column, column.id, "list_alt")}
                      {renderActionIcon("delete", column, column.id, "delete")}
                      <div className="recordview_table_column_add_action">
                        {renderActionIcon("add", column, column.id, "add")}
                      </div>
                    </div>
                  )}
                </th>
              ))}
            </ReactSortable>
          ) : (
            <tr>
              <th>----</th>
              <th>----</th>
              <th>----</th>
              <th>----</th>
            </tr>
          )}
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((row, rowIndex) => (
            <tr key={row}>
              {(columns && columns.length > 0 ? columns : Array.from({ length: 4 })) // Generate 4 dummy columns only when `columns` is empty
                .map((column, colIndex) => {
                  if (column?.type === "custom" && column?.custom_type === "button") {
                    return (
                      <td key={`column-${colIndex}`}>
                        {column?.config && column?.config.length > 0 && (
                          <div className="d_flex gap_3">
                            {column?.config.map((config) => {
                              if (config.type === "button") {
                                return (
                                  <ButtonPreview key={config.id} config={config} classes={config.classes?.join(" ")} />
                                );
                              }
                              if (config.type === "dropdown") {
                                return (
                                  <DropdownPreview
                                    key={config.id}
                                    config={config}
                                    classes={config.classes?.join(" ")}
                                  />
                                );
                              } else return <></>;
                            })}
                          </div>
                        )}
                      </td>
                    );
                  } else if (column?.type === "custom" && column?.custom_type === "rich_column") {
                    if (rowIndex === 0) {
                      return (
                        <td key={`column-${colIndex}`}>
                          <RichColumnLayoutRenderer
                            layout={column?.layout_config?.layouts || []}
                            cardIndex={rowIndex}
                            cardWidth={parseInt(column?.width_value) || 200}
                            id={node.id}
                            path={`config.columns.${colIndex}.layout_config.layouts`}
                          />
                        </td>
                      );
                    } else {
                      return (
                        <td key={`column-${colIndex}`} style={{ width: parseInt(column?.width_value) || 200 }}>
                          {/* <PositionedScreen
                            layoutConfig={column?.layout_config?.layouts || []}
                            type="view"
                            screenWidth={parseInt(column?.width_value) || 200}
                            containerClass=""
                          /> */}
                          <LayoutRendererOuter layoutConfig={column?.layout_config?.layouts || []} type="view" />
                        </td>
                      );
                    }
                  } else {
                    return <td key={`column-${colIndex}`}>{column?.placeholder || "---"}</td>;
                  }
                })}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default RVTablePreview;
export { RVCatalogPreview };
